namespace Matrix.Data {
    export interface AccountGroupRow {
        AccountGroupCode?: string;
        Name?: string;
        DefaultSortOrder?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        AccountList?: string[];
    }

    export namespace AccountGroupRow {
        export const idProperty = 'AccountGroupCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Data.AccountGroup';
        export const lookupKey = 'Data.AccountGroup';

        export function getLookup(): Q.Lookup<AccountGroupRow> {
            return Q.getLookup<AccountGroupRow>('Data.AccountGroup');
        }
        export const deletePermission = 'DataAdmin:AccountGroup';
        export const insertPermission = 'DataAdmin:AccountGroup';
        export const readPermission = 'Read:AccountGroup';
        export const updatePermission = 'DataAdmin:AccountGroup';

        export declare const enum Fields {
            AccountGroupCode = "AccountGroupCode",
            Name = "Name",
            DefaultSortOrder = "DefaultSortOrder",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            AccountList = "AccountList"
        }
    }
}
